(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-with-purchase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__gwpReady) { if (window.__gwpScan) window.__gwpScan(); return; }
    window.__gwpReady = true;

    var GIFT_PROP = '_free_gift';
    var controllers = [];
    var internal = false;
    var syncTimer = null;
    var activeDiscountCode = null;

    function money(cents, currency) {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {
        return '$' + (Math.round(cents) / 100).toFixed(2);
      }
    }

    function getCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }

    function isGift(item, cfg) {
      var p = item.properties || {};
      return p[GIFT_PROP] === 'true' || item.variant_id === cfg.variantId || item.id === cfg.variantId;
    }

    function qualifyingTotal(cart, cfg) {
      return cart.items.reduce(function (sum, i) {
        return isGift(i, cfg) ? sum : sum + i.final_line_price;
      }, 0);
    }

    function addGift(cfg) {
      internal = true;
      var props = {};
      props[GIFT_PROP] = 'true';
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: cfg.variantId, quantity: 1, properties: props }] })
      }).then(function () {
        if (cfg.code) { return fetch('/discount/' + encodeURIComponent(cfg.code)).catch(function () {}); }
      }).catch(function () {}).then(function () { internal = false; });
    }

    function removeGift(key) {
      internal = true;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).catch(function () {}).then(function () { internal = false; });
    }

    // Re-render the theme's cart drawer via the Section Rendering API so the
    // gift line shows up without a page refresh. Swaps inner content only, so
    // the <form is="cart-drawer"> element (and its open state) is preserved;
    // Stimulus re-binds the qty/remove actions to the new DOM automatically.
    function refreshCartDrawer() {
      var form = document.getElementById('CartDrawer-Form');
      if (!form) return Promise.resolve();
      var sectionId = form.getAttribute('data-section-id');
      if (!sectionId) return Promise.resolve();
      return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId), { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('CartDrawer-Form');
          if (fresh) { form.innerHTML = fresh.innerHTML; }
        })
        .catch(function () {});
    }

    function notifyTheme() {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    }

    // Proactively write the discount onto every checkout link so it is
    // applied (and visible on hover). When no gift is active, revert any
    // discount-redirect links back to a plain /checkout.
    function applyCheckoutDiscount() {
      var links = document.querySelectorAll('a[href]');
      links.forEach(function (a) {
        var href = a.getAttribute('href');
        if (!href) return;
        var path;
        try { path = new URL(href, window.location.origin).pathname; } catch (e) { return; }
        var isCheckout = path === '/checkout' || path === '/checkout/';
        var isDiscountRedirect = path.indexOf('/discount/') === 0 && href.indexOf('redirect=/checkout') !== -1;

        if (activeDiscountCode) {
          if (isCheckout) {
            a.setAttribute('href', '/discount/' + encodeURIComponent(activeDiscountCode) + '?redirect=/checkout');
          }
        } else if (isDiscountRedirect) {
          a.setAttribute('href', '/checkout');
        }
      });
    }

    function render(ctrl, total, qualifies) {
      var cfg = ctrl.cfg;
      if (!ctrl.message) return;
      if (qualifies) {
        ctrl.message.textContent = cfg.messages.unlocked.replace(/\{\{\s*gift\s*\}\}/g, cfg.giftTitle);
        if (ctrl.fill) ctrl.fill.style.width = '100%';
      } else {
        var remaining = Math.max(0, cfg.threshold - total);
        ctrl.message.textContent = cfg.messages.progress
          .replace(/\{\{\s*amount\s*\}\}/g, money(remaining, cfg.currency))
          .replace(/\{\{\s*gift\s*\}\}/g, cfg.giftTitle);
        if (ctrl.fill) ctrl.fill.style.width = Math.min(100, cfg.threshold ? (total / cfg.threshold) * 100 : 0) + '%';
      }
    }

    function syncOne(ctrl, cart) {
      var cfg = ctrl.cfg;
      if (!cfg.variantId) { render(ctrl, 0, false); return Promise.resolve(); }
      var total = qualifyingTotal(cart, cfg);
      var gift = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (isGift(cart.items[i], cfg)) { gift = cart.items[i]; break; }
      }
      var qualifies = total >= cfg.threshold;
      render(ctrl, total, qualifies);

      var mutated = false;
      var action = Promise.resolve();
      if (cfg.autoAdd) {
        if (qualifies && !gift) { action = addGift(cfg); mutated = true; }
        else if (!qualifies && gift) { action = removeGift(gift.key); mutated = true; }
      }

      var active = cfg.autoAdd ? qualifies : (gift != null);
      activeDiscountCode = (cfg.code && active) ? cfg.code : null;

      return action.then(function () {
        if (mutated) {
          return refreshCartDrawer().then(function () {
            applyCheckoutDiscount();
            notifyTheme();
          });
        }
        applyCheckoutDiscount();
      });
    }

    function syncAll() {
      if (!controllers.length) return;
      getCart().then(function (cart) {
        var chain = Promise.resolve();
        controllers.forEach(function (c) {
          chain = chain.then(function () { return syncOne(c, cart); });
        });
        return chain;
      }).catch(function () {});
    }

    function scheduleSync() {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(syncAll, 250);
    }

    function isCartMutation(url) {
      return typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
    }

    // Detect cart changes the theme makes (fetch-based).
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
      var promise = origFetch.apply(this, arguments);
      if (isCartMutation(url) && !internal) {
        promise.then(function () { scheduleSync(); }).catch(function () {});
      }
      return promise;
    };

    // Detect cart changes via XHR (older / jQuery-based theme code).
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__gwpCart = isCartMutation(url);
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__gwpCart) {
        this.addEventListener('loadend', function () { if (!internal) scheduleSync(); });
      }
      return origSend.apply(this, arguments);
    };

    // Backup: also enforce the discount at click time, in case the theme
    // re-rendered the drawer after applyCheckoutDiscount() ran.
    document.addEventListener('click', function (e) {
      if (!activeDiscountCode) return;
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var url;
      try { url = new URL(a.getAttribute('href'), window.location.origin); } catch (err) { return; }
      if (url.pathname.indexOf('/discount/') === 0) return;
      if (url.pathname !== '/checkout' && url.pathname !== '/checkout/') return;
      a.setAttribute('href', '/discount/' + encodeURIComponent(activeDiscountCode) + '?redirect=/checkout');
    }, true);

    window.__gwpScan = function () {
      controllers = [];
      document.querySelectorAll('[data-gwp]').forEach(function (el) {
        var cfgEl = el.querySelector('[data-gwp-config]');
        if (!cfgEl) return;
        var cfg;
        try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
        controllers.push({
          el: el,
          cfg: cfg,
          message: el.querySelector('[data-gwp-message]'),
          fill: el.querySelector('[data-gwp-fill]')
        });
      });
      syncAll();
    };

    function boot() { window.__gwpScan(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();

    // Theme editor support
    document.addEventListener('shopify:section:load', function () { window.__gwpScan(); });
    document.addEventListener('shopify:section:unload', function () { window.__gwpScan(); });
  })();

  } catch(e) { console.error(e); }
})();
})();
